/** There is no "form.tsx" for this since the ToS are set at the site level in the General tab */
import React from 'react';
import { Card, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { FeatureConfig, FeatureConfigConfig } from '@juno/client-api/model';
import { useSettings } from '@juno/utils';
import { Container } from '../JunoModule/styles';

interface TermsOfUseConfigConfig extends FeatureConfigConfig {
  title: string;
  body: string;
}
export interface TermsOfUseConfig extends FeatureConfig {
  config: TermsOfUseConfigConfig;
}

const TermsOfUse: React.FC = () => {
  const { configs } = useSettings();

  const termsOfUseConfig = configs?.find(
    (config) => config.type === 'terms_of_use',
  ) as TermsOfUseConfig;
  const termsOfUseConfigConfig = termsOfUseConfig?.config as TermsOfUseConfigConfig;

  const last_update = termsOfUseConfig?.date_updated
    ? new Date(termsOfUseConfig.date_updated).toLocaleDateString('en-US')
    : null;

  return (
    <Container>
      <Card sx={{ p: 2 }}>
        <Typography variant='h5'>{termsOfUseConfigConfig?.title as string}</Typography>
        {last_update && (
          <Typography>
            <i>Last updated: {last_update}</i>
          </Typography>
        )}
        <Typography
          variant='body1'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize((termsOfUseConfigConfig?.body as string) || '', {
              ADD_TAGS: ['iframe'],
              ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
            }),
          }}
        />
      </Card>
    </Container>
  );
};

export default TermsOfUse;
